module.exports = __webpack_public_path__ + "static/media/laptops-desk-background.4e3abe18.jpg";